import styled from 'styled-components';

const Style = styled.div`
  width: 100%;
  padding: var(--size-lg) 30px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.small {
    min-height: 357px;
  }

  .overview-footer {
    display: flex;

    p {
      color: #000000;
      font-weight: 500;
      text-align: center;
      margin-bottom: 0;
      margin-left: auto;
      margin-right: auto;

      .text-blue {
        font-weight: 700;
      }
    }
  }
`;

export const ChartStyle = styled.div`
  width: 100%;
  max-width: 290px;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  &.small {
    max-width: 270px;
  }

  &.no-max-width {
    max-width: 100%;
  }

  svg {
    width: 100%;
    transform: rotate(-90deg);
    background: #EDEDED;
    border-radius: 100%;

    path {
      transition: .1s opacity;
    }
  }

  .info {
    position: absolute;
    width: 75%;
    height: 75%;
    background: white;
    border-radius: 100%;
    top: 50%;
    left: 50%;
    padding: 20px;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
      line-height: 1.5em;
      text-align: center;
      margin: 0px;
      font-size: 20px;
      font-weight: 800px;
      color: #595959;
    }

    .text-blue {
      font-weight: 700;
    }
  }

  &.small-chart {
    width: 80%; 

    .info {
      width: 60%;
      height: 60%;
    }
  }

  &.small-chart-thin {
    width: 80%; 

    .info {
      width: 74%;
      height: 74%;
    }
  }

  &.extra-small-chart {
    width: 65%; 

    .info {
      width: 60%;
      height: 60%;
    }
  }

  &.no-info {
    .info {
      display: none;
    }
  }
`;

export const TooltipStyle = styled.div`
  position: absolute;
  width: 268px;
  left: 0px;
  z-index: 2;
  padding: var(--size);
  border: 1px solid #F2F4F7;
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  border-radius: 4px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 30px;

  .tooltip-header {
    display: flex;

    h6 {
      font-weight: 600;
      font-size: var(--font-size-lg);
      margin-top: 2px;
      margin-bottom: 0px;
    }

    .identifier {
      width: var(--size-lg);
      height: var(--size-lg);
      border-radius: 100%;
      margin-right: 8px;

      img {
        width: 74%;
        height: 74%;
        margin: 13%;
      }
    }
  }

  .tooltip-body {
    p {
      margin-bottom: 0px;
      color: #344054;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    }
  }

  .tooltip-bottom {
    display: flex;
    gap: 17px;

    .item {
      display: flex; 
      gap: 7px;

      label {
        color: #344054;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 0px;
        white-space: nowrap;
        margin-top: -4px;
      }
    }

    svg {
      transform: unset;
      background: unset;
      border-radius: unset;

      path {
        transition: .1s opacity;
      }
    }
  }

`;

export default Style;
